/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * Return all kind of ads for the web portal
 *
 * The version of the OpenAPI document: v0p10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
/**
 * `campaignId` - Id of the campaign
 * @export
 * @interface CreatePersonalOfferRequest
 */
export interface CreatePersonalOfferRequest {
    /**
     * Id of the campaign
     * @type {string}
     * @memberof CreatePersonalOfferRequest
     */
    'campaignId': string;
}
/**
 * `offers` - List of personal offer details
 * @export
 * @interface CreatePersonalOfferResponse
 */
export interface CreatePersonalOfferResponse {
    /**
     * List of personal offer details
     * @type {Array<PersonalOfferDetails>}
     * @memberof CreatePersonalOfferResponse
     */
    'offers': Array<PersonalOfferDetails>;
}
/**
 * @type CreatePersonalOfferResponseResponse
 * @export
 */
export type CreatePersonalOfferResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & CreatePersonalOfferResponseSuccess;

export const CreatePersonalOfferResponseResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type CreatePersonalOfferResponseResponseEnum = typeof CreatePersonalOfferResponseResponseEnum[keyof typeof CreatePersonalOfferResponseResponseEnum];


export interface CreatePersonalOfferResponseSuccess {
    'value': CreatePersonalOfferResponse;
    'Response': CreatePersonalOfferResponseResponseEnum;
}


/**
 * Deal tile to display on the homepage

 * `subtitle` - Subtitle of the deal tile
 * `heroImage` - Hero image hosted on the CDN
 * `actionLink` - Link to the action to take when the deal tile is clicked
 * `stickerText` - Sticker text to display on the deal tile
 * `campaignName` - ID of the campaign
 * `opaqueTrackingData` - Opaque tracking data to send to the tracking api
 * `title` - Title of the deal tile
 * @export
 * @interface DealTile
 */
export interface DealTile {
    /**
     * Subtitle of the deal tile
     * @type {string}
     * @memberof DealTile
     */
    'subtitle': string;
    'priority'?: number;
    /**
     * Hero image hosted on the CDN
     * @type {string}
     * @memberof DealTile
     */
    'heroImage': string;
    'showOnHomeScreen': boolean;
    'showInFlashSale': boolean;
    /**
     * Link to the action to take when the deal tile is clicked
     * @type {string}
     * @memberof DealTile
     */
    'actionLink': string;
    /**
     * Sticker text to display on the deal tile
     * @type {string}
     * @memberof DealTile
     */
    'stickerText': string;
    'showOnDealsPage': boolean;
    /**
     * ID of the campaign
     * @type {string}
     * @memberof DealTile
     */
    'campaignName': string;
    'badge'?: string;
    /**
     * Opaque tracking data to send to the tracking api
     * @type {string}
     * @memberof DealTile
     */
    'opaqueTrackingData'?: string;
    /**
     * Title of the deal tile
     * @type {string}
     * @memberof DealTile
     */
    'title': string;
}
export interface DealTileDealsPage {
    'DisplayAdPlacement': DisplayAdPlacementEnum;
}


export interface DealTileHomescreen {
    'DisplayAdPlacement': DisplayAdPlacementEnum;
}


/**
 * @type Discount
 * Discount Type
 * @export
 */
export type Discount = { Discount: 'Percentage' } & Percentage | { Discount: 'Specific' } & Specific;

export const DiscountEnum = {
    Percentage: 'Percentage',
    Specific: 'Specific'
} as const;

export type DiscountEnum = typeof DiscountEnum[keyof typeof DiscountEnum];


/**
 * @type DisplayAdPlacement
 * Placement of the ad
 * @export
 */
export type DisplayAdPlacement = { DisplayAdPlacement: 'DealTileDealsPage' } & DealTileDealsPage | { DisplayAdPlacement: 'DealTileHomescreen' } & DealTileHomescreen | { DisplayAdPlacement: 'FlashSale' } & FlashSale | { DisplayAdPlacement: 'FlightsInlineAd' } & FlightsInlineAd | { DisplayAdPlacement: 'HotelsInlineAd' } & HotelsInlineAd | { DisplayAdPlacement: 'RotatingBanner' } & DisplayAdPlacementRotatingBanner | { DisplayAdPlacement: 'Unspecified' } & Unspecified;

export const DisplayAdPlacementEnum = {
    DealTileDealsPage: 'DealTileDealsPage',
    DealTileHomescreen: 'DealTileHomescreen',
    FlashSale: 'FlashSale',
    FlightsInlineAd: 'FlightsInlineAd',
    HotelsInlineAd: 'HotelsInlineAd',
    RotatingBanner: 'RotatingBanner',
    Unspecified: 'Unspecified'
} as const;

export type DisplayAdPlacementEnum = typeof DisplayAdPlacementEnum[keyof typeof DisplayAdPlacementEnum];


export interface DisplayAdPlacementRotatingBanner {
    'DisplayAdPlacement': DisplayAdPlacementEnum;
}


export interface ErrorCode {
    'code': string;
    'details'?: string;
}
export interface Failure {
    'errors': Array<ErrorCode>;
    'Response': CreatePersonalOfferResponseResponseEnum;
}


export interface FlashSale {
    'DisplayAdPlacement': DisplayAdPlacementEnum;
}


export interface Flight {
    'OfferType': OfferTypeEnum;
}


export interface FlightsInlineAd {
    'DisplayAdPlacement': DisplayAdPlacementEnum;
}


/**
 * `placement` - Placement of the ad
 * @export
 * @interface GetDealTilesRequest
 */
export interface GetDealTilesRequest {
    'placement': DisplayAdPlacement;
}
/**
 * `dealTiles` - List of deal tiles to display on the homepage
 * @export
 * @interface GetDealTilesResponse
 */
export interface GetDealTilesResponse {
    /**
     * List of deal tiles to display on the homepage
     * @type {Array<DealTile>}
     * @memberof GetDealTilesResponse
     */
    'dealTiles': Array<DealTile>;
}
/**
 * @type GetDealTilesResponseResponse
 * @export
 */
export type GetDealTilesResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & GetDealTilesResponseSuccess;

export const GetDealTilesResponseResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type GetDealTilesResponseResponseEnum = typeof GetDealTilesResponseResponseEnum[keyof typeof GetDealTilesResponseResponseEnum];


export interface GetDealTilesResponseSuccess {
    'value': GetDealTilesResponse;
    'Response': GetDealTilesResponseResponseEnum;
}


/**
 * `campaignId` - Id of the campaign
 * `offerId` - Id of the offer
 * @export
 * @interface GetOfferDetailsRequest
 */
export interface GetOfferDetailsRequest {
    /**
     * Id of the campaign
     * @type {string}
     * @memberof GetOfferDetailsRequest
     */
    'campaignId': string;
    /**
     * Id of the offer
     * @type {string}
     * @memberof GetOfferDetailsRequest
     */
    'offerId': string;
}
/**
 * `offers` - List of personal offer details
 * @export
 * @interface GetOfferDetailsResponse
 */
export interface GetOfferDetailsResponse {
    /**
     * List of personal offer details
     * @type {Array<PersonalOfferDetails>}
     * @memberof GetOfferDetailsResponse
     */
    'offers': Array<PersonalOfferDetails>;
}
/**
 * @type GetOfferDetailsResponseResponse
 * @export
 */
export type GetOfferDetailsResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & GetOfferDetailsResponseSuccess;

export const GetOfferDetailsResponseResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type GetOfferDetailsResponseResponseEnum = typeof GetOfferDetailsResponseResponseEnum[keyof typeof GetOfferDetailsResponseResponseEnum];


export interface GetOfferDetailsResponseSuccess {
    'value': GetOfferDetailsResponse;
    'Response': GetOfferDetailsResponseResponseEnum;
}


/**
 * `banners` - List of banners to display on the homepage
 * @export
 * @interface GetRotatingBannersResponse
 */
export interface GetRotatingBannersResponse {
    /**
     * List of banners to display on the homepage
     * @type {Array<RotatingBanner>}
     * @memberof GetRotatingBannersResponse
     */
    'banners': Array<RotatingBanner>;
}
/**
 * @type GetRotatingBannersResponseResponse
 * @export
 */
export type GetRotatingBannersResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & GetRotatingBannersResponseSuccess;

export const GetRotatingBannersResponseResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type GetRotatingBannersResponseResponseEnum = typeof GetRotatingBannersResponseResponseEnum[keyof typeof GetRotatingBannersResponseResponseEnum];


export interface GetRotatingBannersResponseSuccess {
    'value': GetRotatingBannersResponse;
    'Response': GetRotatingBannersResponseResponseEnum;
}


export interface Home {
    'OfferType': OfferTypeEnum;
}


export interface Hotel {
    'OfferType': OfferTypeEnum;
}


export interface HotelsInlineAd {
    'DisplayAdPlacement': DisplayAdPlacementEnum;
}


/**
 * `uri` - Link to the image hosted on the CDN
 * `alt` - Alt text for the image
 * @export
 * @interface ImageInfo
 */
export interface ImageInfo {
    /**
     * Link to the image hosted on the CDN
     * @type {string}
     * @memberof ImageInfo
     */
    'uri': string;
    /**
     * Alt text for the image
     * @type {string}
     * @memberof ImageInfo
     */
    'alt': string;
}
/**
 * Scranton offer details

 * `slug` - Offer name
 * `arrangement` - Offer arrangement used for display purpose
 * `discount` - Discount value
 * `offerType` - Offer type
 * @export
 * @interface OfferConfiguration
 */
export interface OfferConfiguration {
    /**
     * Offer name
     * @type {string}
     * @memberof OfferConfiguration
     */
    'slug': string;
    /**
     * Offer arrangement used for display purpose
     * @type {string}
     * @memberof OfferConfiguration
     */
    'arrangement': string;
    'discount': Discount;
    'offerType': OfferType;
}
/**
 * @type OfferType
 * The type of offer
 * @export
 */
export type OfferType = { OfferType: 'Flight' } & Flight | { OfferType: 'Home' } & Home | { OfferType: 'Hotel' } & Hotel;

export const OfferTypeEnum = {
    Flight: 'Flight',
    Home: 'Home',
    Hotel: 'Hotel'
} as const;

export type OfferTypeEnum = typeof OfferTypeEnum[keyof typeof OfferTypeEnum];


/**
 * Percentage off discount

 * `discountPercent` - Discount value
 * `maxDiscountAmount` - Maximum discount value
 * @export
 * @interface Percentage
 */
export interface Percentage {
    /**
     * Discount value
     * @type {number}
     * @memberof Percentage
     */
    'discountPercent': number;
    'maxDiscountAmount': Amount;
    'Discount': DiscountEnum;
}


/**
 * Display details of a personal offer

 * `title` - Display name
 * `imageUri` - Link to the display image
 * `offerConfig` - Scranton offer details
 * `items` - List of conditions to be displayed with the offer
 * @export
 * @interface PersonalOfferDetails
 */
export interface PersonalOfferDetails {
    /**
     * Display name
     * @type {string}
     * @memberof PersonalOfferDetails
     */
    'title': string;
    /**
     * Link to the display image
     * @type {string}
     * @memberof PersonalOfferDetails
     */
    'imageUri': string;
    'offerConfig': OfferConfiguration;
    /**
     * List of conditions to be displayed with the offer
     * @type {Array<string>}
     * @memberof PersonalOfferDetails
     */
    'items': Array<string>;
}
/**
 * `ctaText` - Optional copy of the banner cta text localized in the user's language
 * `subtitle` - Copy of the banner subtitle localized in the user's language
 * `heroImage` - Hero image hosted on the CDN
 * `logoImage` - Optional logo image
 * `trackingProperties` - Tracking properties for the banner
 * `campaignName` - ID of the campaign
 * `opaqueTrackingData` - Opaque tracking data to send to the tracking api
 * `title` - Copy of the banner title localized in the user's language
 * `ctaLink` - Link to the destination of the banner. Can be a relative path or an external URL
 * @export
 * @interface RotatingBanner
 */
export interface RotatingBanner {
    /**
     * Optional copy of the banner cta text localized in the user's language
     * @type {string}
     * @memberof RotatingBanner
     */
    'ctaText'?: string;
    /**
     * Copy of the banner subtitle localized in the user's language
     * @type {string}
     * @memberof RotatingBanner
     */
    'subtitle': string;
    'heroImage': ImageInfo;
    'logoImage'?: ImageInfo;
    'trackingProperties': TrackingProperties;
    /**
     * ID of the campaign
     * @type {string}
     * @memberof RotatingBanner
     */
    'campaignName': string;
    /**
     * Opaque tracking data to send to the tracking api
     * @type {string}
     * @memberof RotatingBanner
     */
    'opaqueTrackingData'?: string;
    /**
     * Copy of the banner title localized in the user's language
     * @type {string}
     * @memberof RotatingBanner
     */
    'title': string;
    'finePrint'?: string;
    /**
     * Link to the destination of the banner. Can be a relative path or an external URL
     * @type {string}
     * @memberof RotatingBanner
     */
    'ctaLink': string;
}
/**
 * Specific amount discount

 * `amount` - Discount value
 * @export
 * @interface Specific
 */
export interface Specific {
    'amount': Amount;
    'Discount': DiscountEnum;
}


/**
 * `opaqueTrackingData` - base64 encoded tracking data
 * @export
 * @interface TrackClickRequest
 */
export interface TrackClickRequest {
    /**
     * base64 encoded tracking data
     * @type {string}
     * @memberof TrackClickRequest
     */
    'opaqueTrackingData': string;
}
/**
 * @type TrackClickResponseResponse
 * @export
 */
export type TrackClickResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & TrackClickResponseSuccess;

export const TrackClickResponseResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type TrackClickResponseResponseEnum = typeof TrackClickResponseResponseEnum[keyof typeof TrackClickResponseResponseEnum];


export interface TrackClickResponseSuccess {
    'value': object;
    'Response': TrackClickResponseResponseEnum;
}


/**
 * `opaqueTrackingData` - base64 encoded tracking data
 * @export
 * @interface TrackImpressionRequest
 */
export interface TrackImpressionRequest {
    /**
     * base64 encoded tracking data
     * @type {string}
     * @memberof TrackImpressionRequest
     */
    'opaqueTrackingData': string;
}
/**
 * @type TrackImpressionResponseResponse
 * @export
 */
export type TrackImpressionResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & TrackImpressionResponseSuccess;

export const TrackImpressionResponseResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type TrackImpressionResponseResponseEnum = typeof TrackImpressionResponseResponseEnum[keyof typeof TrackImpressionResponseResponseEnum];


export interface TrackImpressionResponseSuccess {
    'value': object;
    'Response': TrackImpressionResponseResponseEnum;
}


/**
 * Tracking properties for the banner
 * @export
 * @interface TrackingProperties
 */
export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
export interface Unspecified {
    'DisplayAdPlacement': DisplayAdPlacementEnum;
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the list of deal tiles to display on the homepage
         * @param {GetDealTilesRequest} getDealTilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsDealTilesPost: async (getDealTilesRequest: GetDealTilesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getDealTilesRequest' is not null or undefined
            assertParamExists('apiV0AdsDealTilesPost', 'getDealTilesRequest', getDealTilesRequest)
            const localVarPath = `/api/v0/ads/deal-tiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDealTilesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a personal offer for a given campaign and user
         * @param {CreatePersonalOfferRequest} createPersonalOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsOffersCreatePost: async (createPersonalOfferRequest: CreatePersonalOfferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPersonalOfferRequest' is not null or undefined
            assertParamExists('apiV0AdsOffersCreatePost', 'createPersonalOfferRequest', createPersonalOfferRequest)
            const localVarPath = `/api/v0/ads/offers/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPersonalOfferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the display details of a specific ad campaign offer
         * @param {GetOfferDetailsRequest} getOfferDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsOffersDetailsPost: async (getOfferDetailsRequest: GetOfferDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getOfferDetailsRequest' is not null or undefined
            assertParamExists('apiV0AdsOffersDetailsPost', 'getOfferDetailsRequest', getOfferDetailsRequest)
            const localVarPath = `/api/v0/ads/offers/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOfferDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request the list of rotating banners to displayed on the homepage
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsRotatingBannersPost: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('apiV0AdsRotatingBannersPost', 'body', body)
            const localVarPath = `/api/v0/ads/rotating-banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Track a click event
         * @param {TrackClickRequest} trackClickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsTrackClickPost: async (trackClickRequest: TrackClickRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackClickRequest' is not null or undefined
            assertParamExists('apiV0AdsTrackClickPost', 'trackClickRequest', trackClickRequest)
            const localVarPath = `/api/v0/ads/track/click`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackClickRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Track an impression event
         * @param {TrackImpressionRequest} trackImpressionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsTrackImpressionPost: async (trackImpressionRequest: TrackImpressionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackImpressionRequest' is not null or undefined
            assertParamExists('apiV0AdsTrackImpressionPost', 'trackImpressionRequest', trackImpressionRequest)
            const localVarPath = `/api/v0/ads/track/impression`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackImpressionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the list of deal tiles to display on the homepage
         * @param {GetDealTilesRequest} getDealTilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AdsDealTilesPost(getDealTilesRequest: GetDealTilesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealTilesResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AdsDealTilesPost(getDealTilesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AdsDealTilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a personal offer for a given campaign and user
         * @param {CreatePersonalOfferRequest} createPersonalOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AdsOffersCreatePost(createPersonalOfferRequest: CreatePersonalOfferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePersonalOfferResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AdsOffersCreatePost(createPersonalOfferRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AdsOffersCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the display details of a specific ad campaign offer
         * @param {GetOfferDetailsRequest} getOfferDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AdsOffersDetailsPost(getOfferDetailsRequest: GetOfferDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOfferDetailsResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AdsOffersDetailsPost(getOfferDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AdsOffersDetailsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request the list of rotating banners to displayed on the homepage
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AdsRotatingBannersPost(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRotatingBannersResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AdsRotatingBannersPost(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AdsRotatingBannersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Track a click event
         * @param {TrackClickRequest} trackClickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AdsTrackClickPost(trackClickRequest: TrackClickRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackClickResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AdsTrackClickPost(trackClickRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AdsTrackClickPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Track an impression event
         * @param {TrackImpressionRequest} trackImpressionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AdsTrackImpressionPost(trackImpressionRequest: TrackImpressionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackImpressionResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AdsTrackImpressionPost(trackImpressionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0AdsTrackImpressionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Get the list of deal tiles to display on the homepage
         * @param {GetDealTilesRequest} getDealTilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsDealTilesPost(getDealTilesRequest: GetDealTilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDealTilesResponseResponse> {
            return localVarFp.apiV0AdsDealTilesPost(getDealTilesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a personal offer for a given campaign and user
         * @param {CreatePersonalOfferRequest} createPersonalOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsOffersCreatePost(createPersonalOfferRequest: CreatePersonalOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatePersonalOfferResponseResponse> {
            return localVarFp.apiV0AdsOffersCreatePost(createPersonalOfferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the display details of a specific ad campaign offer
         * @param {GetOfferDetailsRequest} getOfferDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsOffersDetailsPost(getOfferDetailsRequest: GetOfferDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOfferDetailsResponseResponse> {
            return localVarFp.apiV0AdsOffersDetailsPost(getOfferDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Request the list of rotating banners to displayed on the homepage
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsRotatingBannersPost(body: object, options?: RawAxiosRequestConfig): AxiosPromise<GetRotatingBannersResponseResponse> {
            return localVarFp.apiV0AdsRotatingBannersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Track a click event
         * @param {TrackClickRequest} trackClickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsTrackClickPost(trackClickRequest: TrackClickRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackClickResponseResponse> {
            return localVarFp.apiV0AdsTrackClickPost(trackClickRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Track an impression event
         * @param {TrackImpressionRequest} trackImpressionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AdsTrackImpressionPost(trackImpressionRequest: TrackImpressionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackImpressionResponseResponse> {
            return localVarFp.apiV0AdsTrackImpressionPost(trackImpressionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Get the list of deal tiles to display on the homepage
     * @param {GetDealTilesRequest} getDealTilesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AdsDealTilesPost(getDealTilesRequest: GetDealTilesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AdsDealTilesPost(getDealTilesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a personal offer for a given campaign and user
     * @param {CreatePersonalOfferRequest} createPersonalOfferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AdsOffersCreatePost(createPersonalOfferRequest: CreatePersonalOfferRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AdsOffersCreatePost(createPersonalOfferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the display details of a specific ad campaign offer
     * @param {GetOfferDetailsRequest} getOfferDetailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AdsOffersDetailsPost(getOfferDetailsRequest: GetOfferDetailsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AdsOffersDetailsPost(getOfferDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request the list of rotating banners to displayed on the homepage
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AdsRotatingBannersPost(body: object, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AdsRotatingBannersPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Track a click event
     * @param {TrackClickRequest} trackClickRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AdsTrackClickPost(trackClickRequest: TrackClickRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AdsTrackClickPost(trackClickRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Track an impression event
     * @param {TrackImpressionRequest} trackImpressionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AdsTrackImpressionPost(trackImpressionRequest: TrackImpressionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AdsTrackImpressionPost(trackImpressionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



